
import useMqtt from '@/utils/usemqtt';
const { startMqtt } = useMqtt();
// import {getLastDevicePosition,getAddress} from "@/api/login"
let myIcons = require("@/assets/img/map33.png");
import { defineComponent, onMounted,reactive,ref} from "vue";
import codeEditor from '@/components/codeEditor/codeEditor.vue';
import { useRouter } from 'vue-router';
export default defineComponent({
    setup() {
    let router=useRouter();
    let add:any =localStorage.getItem("token");
    const lust = JSON.parse(add);
    let deviceSnsss:any = router.currentRoute.value.query.devicesn;
     const objarr = reactive({
          deviceSn:'',
          address:'',
          city:'',
          createtime:'',
          jingdu:'',
          positionId:'',
          remark:'',
          updatetime:"",
          weidu:'',
          receiveNews:"",
      });
      // startMqtt("864784045883364", (topic, message) => {
      //   console.log(message,"41")
      // })

/*/* */
    onMounted(() => {
      
            try{
              let datavalue:any = {}
               startMqtt(deviceSnsss, (topic, message) => {
            //  const msg = JSON.parse(message);
            console.log(message,"66");
            let data = message;
						if(!!data){
						let datatype=data[28];
						 if(data.length < 30){
						 }else{
							let devicesn=[];
							let endIndex=27;
								for(let i=27;i>=10;i--)
								{
									if(data[i]!=0)
										{
										endIndex=i;
										break;
										}
								}
								for(let i=10;i<=endIndex;i++)
								{   
									devicesn.push(data[i]);//((char)data[i]);
								}
							const	devicesnd = devicesn.join("");
							// console.log(devicesnd,"161行打印")
							 // 参数信息010
							 if(datatype==0){
							 	let isReadSet=data[29];
							 	//0是读取1是设置
							 	if(isReadSet==1){
							 		
							 	}else{
                  //  console.log("139")
							 		let paracount=data[30]*256+data[31];//参数个数
							 		if(paracount<9)
							 		return;
							 		datavalue.onlineId=data[32]*256+data[33];//上线状态ID
							 		datavalue.onlneType=data[34];//上线状态数据类型
							 		datavalue.onlineValueLen=data[35]*256+data[36];//上线状态值长度
							 		datavalue.onlineValue=data[37];//上线状态值
							 		datavalue.signalId=data[38]*256+data[39];//信号强度ID
							 		datavalue.signalType=data[40];//信号数据类型
							 		datavalue.signalValueLen=data[41]*256+data[42];//信号值长度
							 		datavalue.signalValue=data[43];//信号值
							 		datavalue.zhaId=data[44]*256+data[45];//iskaizhaID
							 		datavalue.zhaType=data[46];//iskaizha数据类型
							 		datavalue.zhaValueLen=data[47]*256+data[48];//iskaizha长度
							 		datavalue.zhaValue=data[49];//iskaizha值
							 		datavalue.warningId=data[50]*256+data[51];//warningID2
							 		datavalue.warningType=data[52];//warning数据类型
							 		datavalue.warningValueLen=data[53]*256+data[54];//warning长度
							 		datavalue.warningValue=data[55];//warning值
							 		datavalue.voltageId=data[56]*256+data[57];//voltageID
							 		datavalue.voltageType=data[58];//voltage数据类型
							 		datavalue.voltageValueLen=data[59]*256+data[60];//voltage长度
							 		datavalue.voltageValue=data[61]*256+data[62];//voltage值
							 		datavalue.currentId=data[63]*256+data[64];//currentID
							 		datavalue.currentType=data[65];//current数据类型
							 		datavalue.currentValueLen=data[66]*256+data[67];//current长度
							 		datavalue.currentValue=data[68]*256+data[69];//current值
							 		datavalue.leakCurrentId=data[70]*256+data[71];//leakCurrentID
							 		datavalue.leakCurrentType=data[72];//leakCurrent数据类型
							 		datavalue.leakCurrentValueLen=data[73]*256+data[74];//leakCurrent长度
							 		datavalue.leakCurrentValue=data[75]*256+data[76];//leakCurrent值
							 		datavalue.positionTypeId=data[77]*256+data[78];//positionTypeID
							 		datavalue.positionTypeType=data[79];//positionType数据类型
							 		datavalue.positionTypeValueLen=data[80]*256+data[81];//positionType长度
							 		datavalue.positionTypeValue=data[82];//positionType值
							 		datavalue.positionId=data[83]*256+data[84];//positionID
							 		datavalue.positionType=data[85];//position数据类型1
							 		datavalue.positionValueLen=data[86]*256+data[87];//position长度
									datavalue.jingduValue = ((data[88]*256*256*256)+(data[89]*256*256)+(data[90]*256)+(data[91]))/1000000;
									datavalue.weiduValue = ((data[92]*256*256*256)+(data[93]*256*256)+(data[94]*256)+(data[95]))/1000000;
                 }
                //  console.log(datavalue.onlineId,"12312")
								// let address = {
								// 	jingdu:datavalue.jingduValue,
								// 	weidu:datavalue.weiduValue,
                // }
                let addressqq:any = "";
              var params = new URLSearchParams();
              params.append('jingdu', datavalue.jingduValue);
              params.append('weidu',datavalue.weiduValue);
		// 						getAddress(params).then((res)=>{
    //           let data:any = res;
    //           datavalue.address = data.address;

    //           var timezone = 8; //目标时区时间，东八区
		// 				  var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
		// 				  var nowDate = new Date().getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
		// 				  var targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);
		// 				  let datae = new Date(targetDate);
		// 				  var YY = datae.getFullYear() + '-';
		// 				  var MM =(datae.getMonth() + 1 < 10? '0' + (datae.getMonth() + 1): datae.getMonth() + 1) + '-';
		// 				  var DD = datae.getDate() < 10 ? '0' + datae.getDate() : datae.getDate();
		// 				  var hh =(datae.getHours() < 10 ? '0' + datae.getHours() : datae.getHours())+':';
		// 				  var mm =(datae.getMinutes() < 10 ? '0' + datae.getMinutes() : datae.getMinutes()) +':';
		// 				  var ss =datae.getSeconds() < 10 ? '0' + datae.getSeconds() : datae.getSeconds();
		// 				 let mydatavalue = `${YY}${MM}${DD} ${hh}${mm}${ss}`;
    //   // @ts-ignore //忽略提示
    // let map = new BMap.Map("map"); // 创建地图实例
    // // @ts-ignore //忽略提示
    // let point = new BMap.Point(datavalue.jingduValue, datavalue.weiduValue); // 创建点坐标
    // map.enableScrollWheelZoom(true);//鼠标滑动地图
    // map.centerAndZoom(point, 10);
    // //  @ts-ignore //忽略提示
    // // 将标注添加到地图中  
    //   let datas = [{ x: datavalue.jingduValue, y: datavalue.weiduValue, name: '王五' }]
    //   datas.forEach((e, i) => {
    //     // 创建point, 将x,y值传入
    //     //  @ts-ignore //忽略提示
    //     let pointNumber = new BMap.Point(e.x, e.y)
    //     // 创建信息窗口对象 
    //    var opts = {
		// 		width: 300,     // 信息窗口宽度
		// 		height: 110,     // 信息窗口高度
		// 		title : "设备信息", // 信息窗口标题
		// 		message:""
    //         };
             
		// 	var content = `<p>&nbsp;设备编号:&nbsp;${devicesnd}</p>
		// 	<p>&nbsp;设备位置:&nbsp;${datavalue.address}</p>
		// 	<p>&nbsp;设备时间:&nbsp;${mydatavalue}</p>`
    //         //  @ts-ignore //忽略提示
    //     var infoWindow = new BMap.InfoWindow(content, opts);  // 创建信息窗口对象
    //     // 将data中的name加入地图中
    //     //  @ts-ignore //忽略提示
    //     var label = new BMap.Label(e.name, {
    //         //  @ts-ignore //忽略提示
    //       offset: new BMap.Size(25, 5)
    //     });
    //     markerFun(pointNumber, infoWindow, label)
    //   })
    //     //  @ts-ignore //忽略提示
    //   function markerFun(point, infoWindows, label) {
    //       //  @ts-ignore //忽略提示
    //       //  var myIcon = new BMap.Icon(require("@/assets/img/map33.png"), new BMap.Size(84, 84)) 
    //       var myIcon = new BMap.Icon(myIcons, new BMap.Size(84, 84)) 
    //       // var myIcon = new BMap.Icon(require(`${myIcons}`), new BMap.Size(84, 84)) 
    //         //  @ts-ignore //忽略提示
    //         var marker = new BMap.Marker(point, { icon: myIcon }) // 创建标注   
    //         map.addOverlay(marker) // 将标注添加到地图中
    //       //  @ts-ignore //忽略提示
    //     // marker.setLabel(label);  // 将data中的name添加到地图中
    //     // 标注的点击事件
    //     //  @ts-ignore //忽略提示
    //     marker.addEventListener("click", function (event) {
    //         // console.log(event,"67")
    //       map.openInfoWindow(infoWindows, point);//参数：窗口、点  根据点击的点出现对应的窗口
    //     });
    //   }
		// })
 
      // 获取当前地理位置
      //  @ts-ignore //忽略提示
    //   var geolocation = new BMap.Geolocation();
    //   //  @ts-ignore //忽略提示
    //   geolocation.getCurrentPosition(function (r) {
    //       //  @ts-ignore //忽略提示
    //     if (this.getStatus() == BMAP_STATUS_SUCCESS) {
    //         //  @ts-ignore //忽略提示
    //       var mk = new BMap.Marker(r.point);
    //       map.addOverlay(mk);
    //       map.panTo(r.point);
    //       // alert('您的位置：' + r.point.lng + ',' + r.point.lat);
    //     } else {
    //       // alert('failed' + this.getStatus());
    //     }
    //   });
    // })
        }else if(datatype==1){//指令设置
        }
      }
    }
});
  }catch(err){console.log("请先设置密钥")}
        });
        return{
         objarr,
        //  datavalue,
     } 
    },
    components: {
        codeEditor
    },
});
